import Request from '../utils/request';
const commonPath = '/landTransportApi/owner/gateway/truckBrokerShipper'; // 普通货主模式
const plattformPath = '/landTransportApi/owner/gateway/truckBrokerPlatForm' // 平台模式

// 获取验证码
export async function getVerificateCode(params) {
  let requestUrl = `${commonPath}/getVerificateCode`;
  if (Number(params.platformCode) === 100) {
    requestUrl = `${plattformPath}/getVerificateCode`;
  }
  return Request(requestUrl, {
    method: 'GET',
    body: {
      ...params,
    },
  });
}

// 记录特别授权协议签订
export async function recordSpecialAuthAgreement(params){
  let url = `${plattformPath}/insertTruckBrokerOutAgreementRecord`;
  return Request(url, {
     method: 'POST',
     headers:{
      "Content-Type": "application/json"
     },
     body:{
       ...params,
     }
  });
}

// 确认授权
export async function register(params) {
  let requestUrl = `${commonPath}/register`;
  if (Number(params.platformCode) === 100) {
    requestUrl = `${plattformPath}/registerSignContract`;
  }
  return Request(requestUrl, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: {
      ...params,
    },
  });
}

// 查询是否授权认证
export async function selectAuthDriverDetail(params) {
  let requestUrl = `${commonPath}/selectAuthDriverDetail`;
  if (Number(params.platformCode) === 100) {
    requestUrl = `${plattformPath}/selectAuthDriverDetail`;
  }
  return Request(requestUrl, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: {
      ...params,
    },
  });
}

// 查询未签订合同列表
export async function selectNoSignedContractListForTms(params) {
  let requestUrl = `${commonPath}/selectNoSignedContractList`;
  if (Number(params.platformCode) === 100) {
    requestUrl = `${plattformPath}/selectNoSignedContractListExcludeDriverCheck`;
  }
  return Request(requestUrl, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      "Content-Type": "application/json",
    },
    body: {
      ...params,
    },
  });
}

// 签订协议
export async function signTruckBrokerContractForTms(params) {
  let requestUrl = `${commonPath}/signTruckBrokerContractForTms`;
  if (Number(params.platformCode) === 100) {
    requestUrl = `${plattformPath}/registerSignContract`;
  }
  return Request(requestUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: {
      ...params,
    },
  });
}

// 获取三方协议信息
export async function queryThirdPartySystem(params) {
  let requestUrl = `${commonPath}/queryThirdPartySystem`;
  if (Number(params.platformCode) === 100) {
    requestUrl = `${plattformPath}/queryThirdPartySystem`;
  }
  return Request(requestUrl, {
    method: 'GET',
    body: {
      ...params,
    },
  });
}

// 查询协议详情
export async function selectTruckBrokerContract(params) {
  return Request(`/landTransportApi/driver/app/truckBrokerContract/selectTruckBrokerContract`, {
    method: 'GET',
    body: {
      ...params,
    },
  });
}


// WEBPACK FOOTER //
// ./src/services/author.js